<template>
  <div class="input-container">
    <label class="mb-0" :class="{ labelObrigatorio: campoVazio && required && isReady, breakLine: !shouldBreakLine }"> {{ label }}</label>
    <div
      class="field"
      :class="{
        'has-addons': hasAddOn
      }"
    >
      <p v-if="hasAddOn" class="control">
        <button type="button" tabindex="-1" class="button is-static no-boxsizing is-terciary is-loading-darker">R$</button>
      </p>
      <p class="control is-flex-grow-1">
        <input
          :id="id"
          ref="inputValor"
          v-bind="inputConfiguration.attributes"
          v-model="valorEmUso"
          class="input"
          :class="{
            inValida: emValidacao && (valorEmUso == '' || isValorEmUsoZero) && isReady
          }"
          :required="required"
          :placeholder="placeholder"
          :value="valorEmUso"
          :disabled="isDisabled"
          @input="($event) => executarAlteracoes($event.target.value)"
          @focus="($event) => tratamentosAoEntrar($event.target.value)"
        />
      </p>
    </div>
    <span v-if="tipLabel" class="tip-label is-size-7">{{ tipLabel }}</span>

    <div v-if="required && isReady" class="mensagemDeErro">
      <span v-if="emValidacao && (valorEmUso == '' || isValorEmUsoZero)" class="campo-obrigatório">{{ label }} é obrigatório.</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TrfInputValor',
  props: {
    label: {
      type: String,
      default: ''
    },
    tipLabel: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    modelValue: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      default: ''
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    shouldBreakLine: {
      type: Boolean,
      default: true,
      required: false
    },
    emValidacao: {
      type: Boolean,
      default: false
    },
    tipoConfiguracao: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: true
    }
  },
  emits: ['update:modelValue'],
  data() {
    return {
      campoVazio: false,
      isDataValida: true,
      valorEmUso: ''
    };
  },
  computed: {
    isReady() {
      return !this.isDisabled
    },
    hasAddOn() {
      const hasLocale = this.inputConfiguration?.locale && this.inputConfiguration?.locale?.currency;
      return hasLocale;
    },
    isValorEmUsoZero() {
      const valorSemPontuacao = this.valorEmUso.replaceAll(':','').replaceAll(',','').replaceAll('.','').trim();
      const arrayValorPorCaractere = valorSemPontuacao.split('');
      const isTudoZero = arrayValorPorCaractere.every(valor => {
        return valor == '0';
      })
      return isTudoZero
    },
    inputConfiguration() {
      const configs = {
        attributes: {
          type: 'text',
          maxlength: '24'
        },
        locale: {
          locale: 'pt-br',
          currency: 'BRL',
          minimumFractionDigits: 2
        },
        validationFn: this.validarValor
      };
      return configs;
    },
    validity() {
      const input = this.$refs.inputValor;
      const validity = {
        ...input.validity,
        isValorInvalido: !this.inputConfiguration.validationFn
      };

      return validity;
    }
  },
  watch: {
    modelValue: {
      immediate: true,
      async handler(novo, velho) {
        if(novo == velho) return;
        this.executarAlteracoes(novo);
      }
    }
  },
  methods: {
    inicializarInput(valor) {
      if(valor == this.valorEmUso) return;
      this.executarAlteracoes(valor);
    },
    executarAlteracoes(valorInserido) {
      let valor = valorInserido;
      valor = `${valor}`.replaceAll(/[^0-9]+/g, '');
      if (this.inputConfiguration?.locale) {
        valor = this.aplicarLocale(valor, this.inputConfiguration.locale);
      }

      if (this.inputConfiguration?.formatFn) {
        valor = this.inputConfiguration.formatFn(valor);
      }
      
      this.valorEmUso = valor;
      this.emitirInput(this.valorEmUso);
    },
    aplicarLocale(valor, locale) {
      if (!Number(valor)) return '';
      valor = Number(valor) / 100;
      const localeConfig = { ...locale };
      delete localeConfig.locale;

      const valorFormatado = valor.toLocaleString(locale.locale, { ...localeConfig });

      return `${valorFormatado}`;
    },
    validarValor() {
      return Number(this.valorEmUso) / 100 > 0;
    },
    isValid() {
      return Object.values(this.validity).every((item) => item === false);
    },
    emitirInput(valor) {
      this.$emit('update:modelValue', valor);
    },
    tratamentosAoEntrar(valor) {
      if (valor == '') {
        this.valorEmUso = '0,00';
      }
    },
    clear() {
      this.valorEmUso = '';
      this.emitirInput(this.valorEmUso);
    },
    focus() {
      const component = this.$el;
      if (component) {
        const input = component.querySelector(`#${this.id}`);
        setTimeout(() => {
          input.focus();
        }, 10);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.is-flex-grow-1 {
  flex-grow: 1;
}
.input-container {
  margin-bottom: 15px;
}

label {
  display: block;
  margin-bottom: 5px;
}
.inValida {
  border: 1px solid #a94442;
}
.mensagemDeErro {
  margin: 0 0 1% 0;
  color: #a94442;
  font-size: 12px;
}
.labelObrigatorio {
  color: #a94442;
}

.breakLine {
  white-space: nowrap;
}

.tip-label {
  color: #4a4a4a;
  vertical-align: top;
}
</style>
